export default __webpack_public_path__ + "static/cartaz2026-a6450b6df3f4366a2b6ba3f5940e58fa.webp";